"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toE164PhoneNumberStringOrUndefined = void 0;
const google_libphonenumber_1 = __importDefault(require("google-libphonenumber"));
const isE164PhoneNumberString_1 = require("./isE164PhoneNumberString");
function toE164PhoneNumberStringOrUndefined(value) {
    const phoneUtil = google_libphonenumber_1.default.PhoneNumberUtil.getInstance();
    if (typeof value !== "string") {
        return undefined;
    }
    let number;
    try {
        number = phoneUtil.parse(value);
    }
    catch (e) {
        return undefined;
    }
    if (!phoneUtil.isValidNumber(number)) {
        return undefined;
    }
    const phoneNumberString = phoneUtil.format(number, google_libphonenumber_1.default.PhoneNumberFormat.E164);
    if (!(0, isE164PhoneNumberString_1.isE164PhoneNumberString)(phoneNumberString)) {
        return undefined;
    }
    return phoneNumberString;
}
exports.toE164PhoneNumberStringOrUndefined = toE164PhoneNumberStringOrUndefined;
//# sourceMappingURL=toE164PhoneNumberStringOrUndefined.js.map